import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6 0.5C2.96243 0.5 0.5 2.96243 0.5 6C0.5 9.03757 2.96243 11.5 6 11.5C9.03757 11.5 11.5 9.03757 11.5 6C11.5 2.96243 9.03757 0.5 6 0.5ZM8.60355 4.85355C8.79882 4.65829 8.79882 4.34171 8.60355 4.14645C8.40829 3.95118 8.09171 3.95118 7.89645 4.14645L5.25 6.79289L4.10355 5.64645C3.90829 5.45118 3.59171 5.45118 3.39645 5.64645C3.20118 5.84171 3.20118 6.15829 3.39645 6.35355L4.89645 7.85355C5.09171 8.04882 5.40829 8.04882 5.60355 7.85355L8.60355 4.85355Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.00008 0.666992C3.94999 0.666992 0.666748 3.95024 0.666748 8.00033C0.666748 12.0504 3.94999 15.3337 8.00008 15.3337C12.0502 15.3337 15.3334 12.0504 15.3334 8.00033C15.3334 3.95024 12.0502 0.666992 8.00008 0.666992ZM11.4715 6.47173C11.7318 6.21138 11.7318 5.78927 11.4715 5.52892C11.2111 5.26857 10.789 5.26857 10.5287 5.52892L7.00008 9.05752L5.47149 7.52892C5.21114 7.26857 4.78903 7.26857 4.52868 7.52892C4.26833 7.78927 4.26833 8.21138 4.52868 8.47173L6.52868 10.4717C6.78903 10.7321 7.21114 10.7321 7.47149 10.4717L11.4715 6.47173Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M9.99992 0.833008C4.93731 0.833008 0.833252 4.93706 0.833252 9.99967C0.833252 15.0623 4.93731 19.1663 9.99992 19.1663C15.0625 19.1663 19.1666 15.0623 19.1666 9.99967C19.1666 4.93706 15.0625 0.833008 9.99992 0.833008ZM14.3392 8.08893C14.6646 7.76349 14.6646 7.23586 14.3392 6.91042C14.0137 6.58498 13.4861 6.58498 13.1607 6.91042L8.74992 11.3212L6.83917 9.41042C6.51374 9.08498 5.9861 9.08498 5.66066 9.41042C5.33523 9.73586 5.33523 10.2635 5.66066 10.5889L8.16066 13.0889C8.4861 13.4144 9.01374 13.4144 9.33918 13.0889L14.3392 8.08893Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14733)">
        <path d="M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6ZM7.89648 4.14648C8.09175 3.95122 8.40825 3.95122 8.60352 4.14648C8.79878 4.34175 8.79878 4.65825 8.60352 4.85352L5.60352 7.85352C5.40825 8.04878 5.09175 8.04878 4.89648 7.85352L3.39648 6.35352L3.3623 6.31543C3.20213 6.11904 3.21343 5.82954 3.39648 5.64648C3.57954 5.46343 3.86904 5.45213 4.06543 5.6123L4.10352 5.64648L5.25 6.79297L7.89648 4.14648ZM11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14733">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14731)">
        <path d="M14.0001 8.00033C14.0001 4.68662 11.3138 2.00033 8.00008 2.00033C4.68637 2.00033 2.00008 4.68662 2.00008 8.00033C2.00008 11.314 4.68637 14.0003 8.00008 14.0003C11.3138 14.0003 14.0001 11.314 14.0001 8.00033ZM10.5287 5.52897C10.7891 5.26862 11.2111 5.26862 11.4714 5.52897C11.7318 5.78932 11.7318 6.21133 11.4714 6.47168L7.47144 10.4717C7.21109 10.732 6.78908 10.732 6.52873 10.4717L4.52873 8.47168L4.48315 8.4209C4.26959 8.15905 4.28465 7.77305 4.52873 7.52897C4.7728 7.28489 5.15881 7.26983 5.42065 7.4834L5.47144 7.52897L7.00008 9.05762L10.5287 5.52897ZM15.3334 8.00033C15.3334 12.0504 12.0502 15.3337 8.00008 15.3337C3.94999 15.3337 0.666748 12.0504 0.666748 8.00033C0.666748 3.95024 3.94999 0.666992 8.00008 0.666992C12.0502 0.666992 15.3334 3.95024 15.3334 8.00033Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14731">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_14729)">
        <path d="M17.4999 9.99967C17.4999 5.85754 14.1421 2.49967 9.99992 2.49967C5.85778 2.49967 2.49992 5.85754 2.49992 9.99967C2.49992 14.1418 5.85778 17.4997 9.99992 17.4997C14.1421 17.4997 17.4999 14.1418 17.4999 9.99967ZM13.1607 6.91048C13.4862 6.58504 14.0137 6.58504 14.3391 6.91048C14.6645 7.23592 14.6645 7.76343 14.3391 8.08887L9.33911 13.0889C9.01367 13.4143 8.48616 13.4143 8.16073 13.0889L5.66073 10.5889L5.60376 10.5254C5.3368 10.1981 5.35563 9.71558 5.66073 9.41048C5.96582 9.10538 6.44832 9.08656 6.77564 9.35352L6.83911 9.41048L8.74992 11.3213L13.1607 6.91048ZM19.1666 9.99967C19.1666 15.0623 15.0625 19.1663 9.99992 19.1663C4.93731 19.1663 0.833252 15.0623 0.833252 9.99967C0.833252 4.93706 4.93731 0.833008 9.99992 0.833008C15.0625 0.833008 19.1666 4.93706 19.1666 9.99967Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_14729">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconCheckCircle: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"check-circle"} {...props} />
);
